module.exports = __webpack_public_path__ + "static/media/kubernetes.6a347940.png";